// extracted by mini-css-extract-plugin
module.exports = {"dp-image-preview":"dp-image-preview____y-BF","dp-image-preview--item":"dp-image-preview--item___13afl"};